module.exports = __webpack_public_path__ + "static/media/fb-icon.a10ac32e.svg";